// Routes reachable without a CapMagic session token.
export const PUBLIC_PATHS = ["/login", "/auto-login", "/saml/acs-verify-token"];

/**
 * True when `path` is one of PUBLIC_PATHS, with or without trailing slash(es)
 * (e.g. "/auto-login" and "/auto-login/"). `path` is a route path, without the
 * query string, so the query (e.g. ?token=...) is unaffected.
 */
export function isPublicRoute(path: string): boolean {
  const normalized = (path || "").replace(/\/+$/, "") || "/";
  return PUBLIC_PATHS.includes(normalized);
}
